import React, { useState } from "react";
import { Box, Typography, TextField, Button, Alert, Container, Paper, Snackbar } from "@mui/material";
import API from "../api";
import Papa from "papaparse"; // Optional: if you want to parse CSV locally for preview

export default function BatchShiftCreate() {
  const [csvText, setCsvText] = useState("");
  const [file, setFile] = useState(null);
  const [sampleVisible, setSampleVisible] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  // Handle file upload changes
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  // Toggle sample display
  const toggleSample = () => {
    setSampleVisible((prev) => !prev);
  };

  // Submit either CSV text or CSV file to backend
  const handleSubmit = async () => {
    try {
      const formData = new FormData();
      if (file) {
        formData.append("csvFile", file);
      } else if (csvText.trim() !== "") {
        formData.append("csvData", csvText);
      } else {
        setSnackbar({ open: true, message: "Please paste CSV text or choose a file.", severity: "error" });
        return;
      }
      const res = await API.post("/shifts/batch-create", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("Batch Create Response:", res.data);
      setSnackbar({ open: true, message: res.data.message, severity: "success" });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Batch creation failed.",
        severity: "error",
      });
    }
  };

  const sampleCSV = `Account,Date,Till Category,Starting Float,Cash Sales,Drivers Wage,Target Cash,Declared Cash,Till Users,Shift Manager,Cash In Amounts,Cash In Descriptions,Cash Out Amounts,Cash Out Descriptions,Till Notes
Main Account,2023-07-20,C2B,100.00,500.00,50.00,600.00,620.00,User1,Manager1,50,Deposit,20,Withdrawal,Sample shift note`;

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Batch Shift Create
      </Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="body1" gutterBottom>
          You can either paste your CSV data below or upload a CSV file.
        </Typography>
        <TextField
          label="Paste CSV Data"
          multiline
          minRows={6}
          fullWidth
          value={csvText}
          onChange={(e) => setCsvText(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button variant="contained" component="label">
          Upload CSV File
          <input type="file" hidden accept=".csv" onChange={handleFileChange} />
        </Button>
        {file && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            Selected file: {file.name}
          </Typography>
        )}
        <Box sx={{ mt: 2 }}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit Batch
          </Button>
          <Button variant="text" sx={{ ml: 2 }} onClick={toggleSample}>
            {sampleVisible ? "Hide Sample CSV" : "Show Sample CSV"}
          </Button>
        </Box>
        {sampleVisible && (
          <Box sx={{ mt: 2, p: 2, backgroundColor: "#f5f5f5", borderRadius: 1, whiteSpace: "pre-wrap" }}>
            {sampleCSV}
          </Box>
        )}
      </Paper>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
